/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-11-21 21:07:50
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';
import BsySelect from '../../BsySelect';
import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterFlowAssistProstatus extends BsyFilterBase {

    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            ...props
        })

        this.dashText = null;
    }


    componentDidMount() {
        super.componentDidMount()

    }


    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.EQ, BsyConfig().CONST.FILTER_METHOD.NE, BsyConfig().CONST.FILTER_METHOD.EP]
    }


    getValue = () => {

        let e = this
        switch (e.method) {
            case BsyConfig().CONST.FILTER_METHOD.EQ:
            case BsyConfig().CONST.FILTER_METHOD.NE:

                return {
                    value: this.dashText.getValue()
                }
            default:
        }
    }

    getContext = (e) => {
        this.dashText = e;
    }

    renderCont = () => {
        let e = this
        let i = this.options;

        let val = this.getMiddleValue();

        switch (e.method) {
            case BsyConfig().CONST.FILTER_METHOD.EQ:
            case BsyConfig().CONST.FILTER_METHOD.NE:
                return <BsySelect
                    theme={this.props.theme}
                    onBeforeAsync={i.onBeforeAsync}
                    allowBlank={true}
                    height={'34px'}
                    value={val ? val.value : null}
                    items={[{
                        text: React.language("mobile.flow.node.doing"),
                        value: BsyConfig().CONST.WORKFLOW.FLOWSTATE.INPROCESS
                    }, {
                        text: React.language("processed"),
                        value: BsyConfig().CONST.WORKFLOW.FLOWSTATE.COMPLETE
                    }]}
                    onStopEdit={e1 => {
                        e.value = e.getValue()
                        BsyUtils.applyFunc(e, i.onStopEdit, [{
                            value: e.getValue(),
                            valueMode: e.valueMode,
                            method: e.method,
                        }, i], !1)
                    }}
                    getContext={this.getContext}

                />
            default:
        }
    }
    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

